import React, { useRef, useState } from "react";
import "./Header.css";

const Account = ({
  isShowDetails,
  setIsShowDetails,
  userData,
  favoriteTrips,
}) => {
  const handleExitClick = () => {
    setIsShowDetails(false);
    document.getElementById("app-root").style.filter = "none";
  };

  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useState(false);

  return (
    <div className={`${isShowDetails ? "active" : ""} show`}>
      <div className="account-box solid">
        <h1 class="under">Your details</h1>
        <button
          type="button"
          class="close"
          className="close"
          aria-label="Close"
          onClick={handleExitClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <br></br>
        <br></br>
        <br></br>
        <div className="row">
          <div className="col-lg-3">
            <h4 class="bold white">Name:</h4>
            <h4 class="white">{userData.name}</h4>
            <br></br>
            <h4 class="bold white">Email: </h4>
            <h4 class="white">{userData.email}</h4>
            <br></br>
            <h4 class="bold white">Phone Number: </h4>
            <h4 class="white">{userData.phone}</h4>
          </div>
          <div className="col-lg-9">
            <div className="menu-container">
              <nav
                ref={dropdownRef}
                className={`menu ${isActive ? "active" : "inactive"}`}
              >
                <ul>
                  {favoriteTrips.map((trip) => {
                    return (
                      <li>
                        <div>
                          tripdId: {trip.tripId}
                          tripDate: {trip.tripDate}
                          hourStart: {trip.hourStart}
                          hourEnd: {trip.hourEnd}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
